export default __webpack_public_path__ + "static/media/data.1fe0a845.jpeg";